import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationNewFolder.messages';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { createApiUrl, appSettings } from 'src/config';
import { requestAPIActions } from 'loopback-react-request';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';


export interface ConfigurationNewFolderProps {
  dispatch: any;
  drilledConfirm: (folderName: string) => void;
  drilledClose: () => void;
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
  isNested?: boolean;
  parentId?: string;
  folderId?: string;
  folderName?: string;
  metavalue?: string;
  groups: GlobalPrivateState['groups'];
  authenticator: GlobalPrivateState['authenticator'];
}

export interface ConfigurationNewFolderState {
  isOpen: boolean; 
  folderName: string; 
  metavalue: string;
}

export class ConfigurationNewFolderPartial extends React.Component<ConfigurationNewFolderProps, ConfigurationNewFolderState> {
  constructor(props: ConfigurationNewFolderProps) {
    super(props);
    this.state = {
      isOpen: false,
      folderName: this.props.folderName || '',
      metavalue: this.props.metavalue || ''
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {
    const { folderName, metavalue } = this.state;
    const { groups, parentId, isNested } = this.props;

    return (
      <Modal 
        isOpen={this.state.isOpen}
				backdrop={true}
				toggle={this.toggleModal}
        className="modal-dialog--small folder-create-modal"
      >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          <button onClick={this.toggleModal} className="close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
					<div>
						<h3 className="modal-heading">
              {parentId ? (
                <FormattedMessage {...MESSAGES.configurationNewFolderNestedHeading} />
              ) : (
                <FormattedMessage {...MESSAGES.configurationNewFolderHeading} />
              )}
            </h3>
						<div className="modal-body">
							<h4 className="modal-smheading"><FormattedMessage {...MESSAGES.configurationNewFolderName} /></h4>
              <input className="mb-3" type="text" value={folderName} onChange={(e) => this.setState({...this.state, folderName: e.target.value})} />

              <h4 className="modal-smheading">{!isNested ? <FormattedMessage {...MESSAGES.configurationNewBuildingNumber} /> : <FormattedMessage {...MESSAGES.configurationNewOpportunityNumber} />}</h4>
              <input type="text" value={metavalue} onChange={(e) => this.setState({...this.state, metavalue: e.target.value})} />
            </div>
						<div className="modal-actions text-center">
							<button 
								className="btn btn-light btn-bordered w-100"
								onClick={this.toggleModal}
                disabled={groups.updating}
							>
								<FormattedMessage {...MESSAGES.configurationNewFolderCancel} />
							</button>
              <button 
                className="btn btn-secondary w-100"
                onClick={this.handleCreate}
                disabled={groups.updating}
              >
                <FormattedMessage {...MESSAGES.configurationNewFolderCreate} />
              </button>
						</div>
					</div>
        </div>
      </Modal>
    );
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.props.drilledClose(), 151);
  } 

  handleCreate = async (event: any) => {
    const { userData, user } = this.props;
    const { folderName, metavalue } = this.state;

    if (!userData.result || !userData.result || !folderName) { return }

    if (this.props.drilledConfirm) { 
      this.props.drilledConfirm(folderName);
    }
    this.toggleModal();

    const values: any = {
      name: folderName,
      metavalue,
      type: 'folder',
      updated_at: new Date().toISOString()
    }

    if (user && user.result) {
      values.userId = user.result.id;
    }

    if (userData && userData.result) {
      values.userdataId = userData.result.id;
    }

    if (this.props.parentId) {
      values.parentId = this.props.parentId;
    }

    // apiOptiPost('groups', '/Groups/', {values})... temporarily update 'groups' with new value, then make request, then handle failure

    const apiUrl = createApiUrl(appSettings.config);
    const accessToken = this.props.authenticator.accessToken && this.props.authenticator.accessToken.id;
    if (!accessToken) return;

    // Add folder to folder list...
    const foldersBefore = this.props.groups.result || [];
    this.props.dispatch(requestAPIActions.loadPlain(
      'groups', 
      [values, ...foldersBefore]
    ));

    // Make request
    const response = await fetch(`${apiUrl}/Groups/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': accessToken
      },
      body: JSON.stringify(values),
    });

    // Restore if failed
    
    if (response.ok) {
      const newFolder = await response.json();
      const foldersBefore = this.props.groups.result || [];
      this.props.dispatch(requestAPIActions.loadPlain(
        'groups', 
        [newFolder, ...foldersBefore]
      ));
    } else {
      const foldersBefore = this.props.groups.result || [];
      this.props.dispatch(requestAPIActions.loadPlain(
        'groups', 
        foldersBefore
      ));
      // TODO - Show a toaster popup warning?
    }
  }
}

// export const UserListDeleteModal = connect((state: GlobalPrivateState) => ({
// }))(UserListDeleteModalPartial as any);

export const ConfigurationNewFolder = connect((state: GlobalPrivateState) => ({
  user: state.user,
  userData: state.userData,
  groups: state.groups,
  authenticator: state.authenticator
}))(ConfigurationNewFolderPartial);

export default ConfigurationNewFolder;